import { MasterMappingListModel } from './../../master-mappings/master-mappings.model';
import { environment } from './../../../environments/environment';
import { element } from 'protractor';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectionModel } from '../../connections/connections.model';
import { DatabaseTableModel } from '../../shared/models/database-table.model';
import { DatabaseColumnModel } from '../../shared/models/database-column.model';
import { ClassificationCategoriesModel } from '../../classification-categories/classification-categories.model';
import { GlobalService } from '../../shared/services/global.service';
import { ClassificationModel } from '../classification.model';
import { ToastrMessageType } from '../../shared/enums/toastr-message-type.enum';
import { MasterMappingModel, RelationshipModel } from '../../master-mappings/master-mappings.model';
import { DxDataGridComponent, DxTextBoxComponent } from 'devextreme-angular';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/finally';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';

import { createStore } from 'devextreme-aspnet-data-nojquery';
import CustomStore from 'devextreme/data/custom_store';
import { ClassifyFormService } from './classify-form.service';

@Component({
  selector: 'app-classify-form',
  templateUrl: './classify-form.component.html',
  styleUrls: ['./classify-form.component.scss']
})
export class ClassifyFormComponent implements OnInit {

  @ViewChild('tableGrid')
  private tableGrid: DxDataGridComponent;

  @ViewChild('masterGrid')
  private masterGrid: DxDataGridComponent;

  @ViewChild('columnGrid')
  private columnGrid: DxDataGridComponent;

  @ViewChildren('mappingGrid')
  private mappingGrids: DxDataGridComponent[];

  @ViewChild('txtPattern')
  private txtPattern: DxTextBoxComponent;

  @ViewChild('previewGrid')
  private previewGrid: DxDataGridComponent;

  private loadPanelVisible = false;
  private form: FormGroup;
  private mappingForm: FormGroup;
  private connectionId: number;
  private activeTab = 'classifyTab';
  private connections: ConnectionModel[];
  private databaseTables: DatabaseTableModel[] = [];
  private databaseColumns: DatabaseColumnModel[];
  private classifications: ClassificationModel[];
  private classificationCategories: ClassificationCategoriesModel[];
  private dataPreviewPopupVisible = false;
  private dataPreview: any;
  private patternHelp: any[] = [];
  private patternRules: any;

  private masterMappings: MasterMappingModel[];
  private relationships: RelationshipModel[];

  private masterMappingsDataSource: DataSource;
  private masterMappingList: MasterMappingListModel[] = [];

  private dataSource: any = {};

  constructor(
    private router: Router,
    private classifyFormService: ClassifyFormService,
    private globalService: GlobalService,
    private formBuilder: FormBuilder) {
      this.patternRules = { 'X': /[0-9]+/ };

      this.form = formBuilder.group({
        classificationId: 0,
        connectionId: 0,
        tableSchema: '',
        tableName: '',
        keyColumn: '',
        columnName: '',
        columnType: '',
        maxLength: '',
        classificationCategoryId: [0, Validators.required],
        description: ['', Validators.required],
        anonymisationPattern: ''
        // anonymisationPattern: new FormControl({ value: '', disabled: false })
      });

      this.mappingForm = formBuilder.group({
        connectionId: 0,
      });

      this.patternHelp = this.classifyFormService.getPatternHelp();

      // this.dataSource.store = new CustomStore({
      //   load: function(loadOptions: any) {
      //     let params = '?';

      //     params += 'skip=' + loadOptions.skip || 0;
      //     params += '&take=' + loadOptions.take || 12;
      //     params += '&connectionid=' + this.form.get('ConnectionId').value;
      //     params += '&tablename=' + this.TableName;

      //     return globalService.httpGet(`/DataPreview${params}`)
      //       .toPromise()
      //       .then(response => {
      //         return {
      //           data: response,
      //           totalCount: response.totalCount
      //         };
      //       });
      //   }
      // });

      this.initialiseData();
  }

  ngOnInit() {
  }

  private initialiseData() {
    this.loadPanelVisible = true;
    Observable.forkJoin(
      this.getConnections(),
      this.getClassificationCategories(),
      this.getMasterMappings()
    )
    .finally(() => this.loadPanelVisible = false)
    .subscribe(results => {
      this.connections = results[0] as ConnectionModel[];
      this.classificationCategories = results[1];
      this.masterMappings = results[2];
      this.masterGrid.instance.expandAll(-1);
    });
  }

  private onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        hint: 'Preview Table Data',
        icon: 'info',
        onClick: this.previewTableData.bind(this)
      }
    });
  }

  private onMappingToolbarPreparing(e: any, grid: DxDataGridComponent) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        hint: 'Clear Selection',
        icon: 'clear',
        onClick: this.clearGridSelection.bind(this, grid)
      }
    });
  }

  private clearGridSelection(grid: DxDataGridComponent) {
    grid.instance.deselectAll();
  }

  private previewTableData() {
    this.dataPreview = null;
    this.loadPanelVisible = true;
    this.globalService.httpGet(`/DataPreview/${this.ConnectionId}/${this.TableSchema}/${this.TableName}`)
      .finally(() => this.loadPanelVisible = false)
      .subscribe(response => {
        const data = response;
        if (response.length >= 1)
          this.dataPreview = response[0].Table;
      });

    this.dataPreviewPopupVisible = true;
  }

  onConnectionChanged(connectionId: number) {
    this.form.patchValue({
      connectionId: connectionId
    });

    this.tableGrid.instance.clearSelection();
    this.getDatabaseTables(connectionId);
  }

  onTableSelectionChanged(connectionId: number, tableName: any) {
    this.form.reset();
    this.mappingGrids.forEach(grid => grid.instance.deselectAll());

    if (this.databaseTables.length >= 1) {
      const currentTable = this.databaseTables.filter(x => x.TableName === tableName[0])[0];
      if (currentTable) {
        this.form.patchValue({
          connectionId: this.connectionId,
          tableSchema: currentTable.TableSchema,
          tableName: currentTable.TableName,
          keyColumn: currentTable.KeyColumn
        });
        this.getRelationships();
        this.getDatabaseColumns(this.connectionId, tableName);
      }
    }
  }

  getDatabaseColumns(connectionId: number, tableName: string) {
    this.globalService.httpGet(`/DatabaseColumns/${connectionId}/${tableName}`)
      .subscribe(result => {
        this.databaseColumns = result as DatabaseColumnModel[];
        this.getClassifications(connectionId, this.form.get('tableName').value);
      }, error => this.globalService.handleErrorObservable(error, 'An error occurred while retrieving Columns'));
  }

  onColumnSelectionChanged() {

    if (this.columnGrid.instance) {
      const data = this.columnGrid.instance.getSelectedRowsData() as DatabaseColumnModel[];
      this.form.get('anonymisationPattern').enable();

      if (data.length !== 1)
        return;

      this.form.patchValue({
        columnName: data[0].ColumnName,
        columnType: data[0].ColumnType,
        maxLength: data[0].MaxLength
      });

      if (this.classifications.length >= 1) {
        const classification = this.classifications.filter((c: ClassificationModel) =>
          c.ColumnName === data[0].ColumnName)[0] as ClassificationModel;

        if (classification)
          this.form.patchValue({
            classificationId: classification.ClassificationId,
            classificationCategoryId: classification.ClassificationCategoryId,
            description: classification.Description,
            anonymisationPattern: classification.AnonymisationPattern
          });
        else
          this.form.patchValue({
            classificationId: 0,
            classificationCategoryId: '',
            description: '',
            anonymisationPattern: ''
          });
      }

      this.txtPattern.maxLength = +this.form.get('maxLength').value;
      let pattern = '';
      if (this.ColumnType.indexOf('int') > -1 || this.ColumnType.indexOf('numeric') > -1) {
        pattern = '\\n';
        this.form.get('anonymisationPattern').disable();
      } else if (this.ColumnType.indexOf('date') > -1) {
        pattern = 'dd/mm/yyyy';
        this.form.get('anonymisationPattern').disable();
      }

      this.form.patchValue({ anonymisationPattern: pattern });

      // if (this.anonymisationPattern === '' && this.ColumnType.indexOf('date') > -1) {
      //   this.form.patchValue({
      //     anonymisationPattern: 'dd/mm/yyyy'
      //   });
      //   this.form.get('anonymisationPattern').disable();
      // }

      if (this.relationships.length >= 1) {
        this.mappingGrids.forEach(x => {
          x.instance.selectRows(this.currentRelationships.map(y => y.LabelId), false);
        });
      } else {
        this.mappingGrids.forEach(x => {
          x.instance.deselectAll();
        });
      }
    }
  }

  private getConnections() {
    return this.globalService.httpGet('/Connections');
  }

  // getConnections() {
  //   this.globalService.httpGet('/Connections')
  //     .subscribe(result => {
  //       this.connections = result as ConnectionModel[];
  //     }, error => {
  //       this.globalService.handleErrorObservable(error, 'An error occured while retrieving Connections.');
  //     });
  // }

  getDatabaseTables(connectionId: number) {
    this.connectionId = connectionId;
    this.tableGrid.instance.beginCustomLoading('Loading Tables...');
    this.globalService.httpGet(`/DatabaseTables/${connectionId}`)
      .finally(() => this.tableGrid.instance.endCustomLoading())
      .subscribe(result => {
        this.databaseTables = result as DatabaseTableModel[];
        this.databaseColumns = [];
      }, error => this.globalService.handleErrorObservable(error, 'An error occured while retrieving Database Tables'));
  }

  private getClassificationCategories() {
    return this.globalService.httpGet('/ClassificationCategories');
  }

  // getClassificationCategories() {
  //   this.globalService.httpGet('/ClassificationCategories')
  //     .subscribe(result => {
  //       this.classificationCategories = result as ClassificationCategoriesModel[];
  //     }, error => {
  //       this.globalService.handleErrorObservable(error, 'An error occured while retrieving Classification Categories.');
  //     });
  // }

  getClassifications(connectionId: number, tableName: string) {
    this.globalService.httpGet(`/Classifications/${connectionId}/${tableName}`)
      .subscribe(result => {
        this.classifications = result as ClassificationModel[];
        for (const col of this.databaseColumns)
          if (this.classifications.filter(c => c.ColumnName === col.ColumnName).length === 1)
            col.HasClassification = true;
      }, error => {
        this.globalService.handleErrorObservable(error, 'An error occured while retrieving Classifications.');
      });
  }

  hasTableClassification(tableName: string) {
    const table = this.databaseTables.filter((x: DatabaseTableModel) => x.TableName === tableName)[0];
    if (table)
      return table.HasClassification;
  }

  hasColumnClassification(columnName: string): boolean {
    const columns = this.databaseColumns.filter((c: DatabaseColumnModel) => c.ColumnName === columnName);

    if (columns.length === 1) {
      return columns[0].HasClassification;
    }

    return false;
  }

  saveClassification() {
    const classification: ClassificationModel = {
      ClassificationId: this.form.get('classificationId').value,
      ConnectionId: this.form.get('connectionId').value,
      TableSchema: this.form.get('tableSchema').value,
      TableName: this.form.get('tableName').value,
      KeyColumn: this.form.get('keyColumn').value,
      ColumnName: this.form.get('columnName').value,
      ColumnType: this.form.get('columnType').value,
      MaxLength: this.form.get('maxLength').value,
      ClassificationCategoryId: this.form.get('classificationCategoryId').value,
      ClassificationCategoryName: '',
      Description: this.form.get('description').value,
      AnonymisationPattern: this.form.get('anonymisationPattern').value
    };

    const currentTable = this.databaseTables.filter(d => d.TableName === classification.TableName);
    if (currentTable.length >= 1)
      currentTable[0].HasClassification = true;

    const currentColumn = this.databaseColumns.filter(c => c.TableName === classification.TableName && c.ColumnName === classification.ColumnName);
    if (currentColumn.length >= 1)
      currentColumn[0].HasClassification = true;

    this.globalService.httpPost(`/Classifications`, classification)
      .subscribe(response => {
        const result = response as ClassificationModel;

        if (result) {
          this.form.patchValue({
            classificationId: result.ClassificationId,
            connectionId: result.ConnectionId,
            tableSchema: result.TableSchema,
            tableName: result.TableName,
            columnName: result.ColumnName,
            columnType: result.ColumnType,
            maxLength: result.MaxLength,
            classificationCategoryId: result.ClassificationCategoryId,
            description: result.Description,
            anonymisationPattern: result.AnonymisationPattern
          });

          const itemIndex = this.classifications.findIndex(x => x.ClassificationId === result.ClassificationId);

          if (itemIndex === -1)
            this.classifications.push(result);
          else
            this.classifications[itemIndex] = result;

          this.globalService.showMessage('Classification Saved.', ToastrMessageType.Success);
        }
      }, error => this.globalService.handleErrorObservable(error, 'An error occurred while saving Classification.'));
  }

  clearClassification() {
    const id = this.form.get('classificationId').value;

    if (id) {
      const cls = this.classifications.filter(x => x.ClassificationId === id)[0];
      this.globalService.httpPost(`/ClearClassification`, cls)
        .subscribe(response => {
          const itemIndex = this.classifications.findIndex(x => x.ClassificationId === id);

          if (itemIndex !== -1) {
            this.classifications.splice(itemIndex, 1);
          }

          const currentColumn = this.databaseColumns.filter(c => c.TableName === c.TableName && c.ColumnName === cls.ColumnName);
          if (currentColumn.length >= 1)
            currentColumn[0].HasClassification = false;

          const currentTable = this.databaseTables.filter(d => d.TableName === cls.TableName);
          if (currentTable.length >= 1)
            if (this.databaseColumns.filter(x => x.TableName === currentTable[0].TableName && x.HasClassification).length === 0)
              currentTable[0].HasClassification = false;

          this.form.patchValue({
            classificationId: 0,
            classificationCategoryId: '',
            description: '',
            anonymisationPattern: ''
          });

          this.globalService.showMessage('Classification Cleared.', ToastrMessageType.Success);
        }, error => {
          this.globalService.handleErrorObservable(error, 'An error occurred while clearing Classification.');
        });
    }
  }

  private getMasterMappings() {
    return this.globalService.httpGet('/MasterMappings');
  }

  // getMasterMappings() {
  //   this.globalService.httpGet('/MasterMappings')
  //     .subscribe(response => {
  //       this.masterMappings = response as MasterMappingModel[];
  //       this.masterGrid.instance.expandAll(-1);
  //     });
  // }

  getRelationships() {
    const connectionId = +this.form.get('connectionId').value;
    const tableName = this.form.get('tableName').value;
    this.globalService.httpGet(`/Relationships/${connectionId}/${tableName}`)
      .subscribe(response => {
        this.relationships = response as RelationshipModel[];
      });
  }

  saveRelationships() {
    const keys: number[] = [];
    const colKeys: string[] = this.columnGrid.instance.getSelectedRowKeys();
    let selected: RelationshipModel[];

    this.mappingGrids.forEach(grid => {
      keys.push.apply(keys, grid.instance.getSelectedRowKeys());
    });

    selected = [];

    keys.forEach(labelId => {
      let relationshipId = 0;
      const cur = this.relationships.filter(x => x.ConnectionId === this.ConnectionId && x.TableName === this.TableName && x.ColumnName === this.ColumnName && x.LabelId === labelId);
      if (cur.length >= 1) {
        relationshipId = cur[0].RelationshipId;
      }

      selected.push({
        RelationshipId: relationshipId,
        ConnectionId: this.ConnectionId,
        TableSchema: this.TableSchema,
        TableName: this.TableName,
        ColumnName: this.ColumnName,
        ColumnType: this.ColumnType,
        LabelId: labelId
      });
    });

    this.globalService.httpPost(`/Relationships/Inactivate/${this.ConnectionId}/${this.TableName}/${this.ColumnName}`).toPromise()
      .then(() => {
        this.globalService.httpPost('/Relationships', selected)
          .subscribe(response => {
            this.relationships = response as RelationshipModel[];
            this.globalService.showMessage('Mappings saved.', ToastrMessageType.Success);

            const currentTable = this.databaseTables.filter(x => x.TableName === this.TableName);
            if (currentTable.length >= 0)
              currentTable[0].HasRelationship = (this.relationships.length >= 1);

            const currentColumn = this.databaseColumns.filter(x => x.TableName === this.TableName && x.ColumnName === this.ColumnName);
            if (currentColumn.length >= 0)
              currentColumn[0].HasRelationship = (this.relationships.length >= 1);
          }, error => this.globalService.handleErrorObservable(error, 'An error occurred while saving these mappings'));
      });
  }

  onSelectionChanged() {
    if (this.activeTab === 'classifyTab')
      this.selectOneColumn();
  }

  onTabChange(id: string) {
    this.activeTab = id;

    if (id === 'classifyTab')
      this.selectOneColumn();
  }

  private selectOneColumn() {
    const keys: string[] = this.columnGrid.instance.getSelectedRowKeys();

    if (keys.length > 1) {
      const selected: string[] = [];
      selected.push(keys[0]);
      this.columnGrid.instance.deselectRows(selected);
    }
  }

  get ConnectionId() { return +this.form.get('connectionId').value; }

  get TableSchema() { return this.form.get('tableSchema').value; }

  get TableName() { return this.form.get('tableName').value; }

  get ColumnName() { return this.form.get('columnName').value; }

  get ColumnType() { return this.form.get('columnType').value; }

  get anonymisationPattern() { return this.form.get('anonymisationPattern').value; }

  get AnonPatternEnabled() {
    return this.form.get('anonymisationPattern').value !== 'dd/mm/yyyy';
  }

  get currentRelationships(): RelationshipModel[] {
    return this.relationships.filter(x => x.ConnectionId === this.ConnectionId && x.TableName === this.TableName && x.ColumnName === this.ColumnName);
  }

  get diagnostic() { return JSON.stringify(this.form.value); }
}
